import { Routes } from '@angular/router';

export const AuctionsRoutes: Routes = [
  {
    path: 'lots/:id',
    // TODO move lot-details to auctions-folder
    loadComponent: () => import('./../lot-details/lot-details.component').then((m) => m.LotDetailsComponent)
  },
  {
    path: 'lots',
    // TODO move catalog to auctions-folder
    loadComponent: () => import('./../catalog/catalog.component').then((m) => m.CatalogComponent)
  },
  {
    path: 'current',
    loadComponent: () => import('./auctions.component').then((m) => m.AuctionsComponent)
  },
  {
    path: 'archive',
    loadComponent: () => import('./auctions.component').then((m) => m.AuctionsComponent)
  },
  {
    path: 'archive/:year',
    loadComponent: () => import('./auctions.component').then((m) => m.AuctionsComponent)
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'current'
  }
];
